import React from 'react';
import EasebuzzCallbackBase from './EasebuzzCallbackBase';

const EasebuzzSuccess = () => <EasebuzzCallbackBase success={true} />;

export default EasebuzzSuccess;
